import { Typography } from "@mui/material";
import React from "react";

const index = (props: { formValue: any }) => {
  return <div className="grid grid-cols-2 gap-3">
    <div className="shadow">
      <Typography variant="h5" align="center">Treatment Name: {props.formValue?.name}</Typography>
      <Typography variant="h5" align="center">Price: {props.formValue?.minPrice} ~ {props.formValue?.maxPrice}</Typography>
    </div>
    <div className="shadow">
      <Typography variant="h5" align="center">Ranges in %</Typography>
      {props.formValue?.ranges !== undefined ?
        props.formValue?.ranges?.map((range: any) => (
          <div className="flex flex-row gap-2 px-10">
            <span><span className="font-bold">Name</span>: {range.name}</span>
            <span><span className="font-bold">Range</span>: {range.min} ~ {range.default} ~ {range.max}</span>
          </div>
        ))
        :
        <Typography variant="h6" align="center">No Range Added!</Typography>
      }
    </div>
  </div>;
};

export default index;
